import { render } from "./Sidebar.vue?vue&type=template&id=1fc380ad&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=1fc380ad&scoped=true&lang=css"
import "./Sidebar.vue?vue&type=style&index=1&id=1fc380ad&lang=css"
script.render = render
script.__scopeId = "data-v-1fc380ad"

export default script